import { useLocation } from '@gatsbyjs/reach-router';

const useIsSearchPage = (): boolean => {
  try {
    const location = useLocation();
    const isSearchPage = location?.pathname.endsWith('/search');

    return isSearchPage;
  } catch (error) {
    if (typeof window !== 'undefined') {
      return window.location.pathname.endsWith('/search');
    }

    console.error('Error in useIsSearchPage', error);
    return false;
  }
};

export default useIsSearchPage;
